import type { ReactNode } from 'react';
import { ConfirmProvider } from './ConfirmProvider';
import { ToastProvider } from './ToastProvider';

/** App-root wrapper: toast queue + confirm dialog (product UiContext parity). */
export function FeedbackProvider({ children }: { children: ReactNode }) {
  return (
    <ToastProvider>
      <ConfirmProvider>{children}</ConfirmProvider>
    </ToastProvider>
  );
}
